// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetMyOffersForSelectionDesktopRequest,
  TGetMyOffersForSelectionDesktopModel,
  IMappers,
  TGetMyOffersForSelectionDesktopResponse,
  IGetMyOffersForSelectionDesktopResponse,
  IGetMyOffersForSelectionDesktopResponseError,
} from './types';

export const defaultConfig: TGetMyOffersForSelectionDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-my-offers-for-selection-desktop/',
} as TGetMyOffersForSelectionDesktopModel;

export function createGetMyOffersForSelectionDesktopModel(
  parameters: IGetMyOffersForSelectionDesktopRequest,
): TGetMyOffersForSelectionDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMyOffersForSelectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMyOffersForSelectionDesktopRequest;
}

export async function fetchGetMyOffersForSelectionDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMyOffersForSelectionDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetMyOffersForSelectionDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetMyOffersForSelectionDesktopModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMyOffersForSelectionDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetMyOffersForSelectionDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetMyOffersForSelectionDesktopResponse;
}
